import { Tooltip } from '@wheely/ui-kit';
import cn from 'classnames';
import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { THourlyWorkloads } from '@/modules/driver/model/driver-workload';
import { WEEKDAYS_SHORT } from '@/shared/view/LocalizedWeekPicker/const';

import { Clock } from './Clock';
import s from './WorkingHoursCalendar.module.css';

interface Props {
  workloads: THourlyWorkloads | null;
}

const WorkingHoursCalendar = ({ workloads }: Props) => (
  <div className={s.calendar}>
    <div className={s.cell} />
    {WEEKDAYS_SHORT.map(weekday => (
      <div key={weekday.id} className={cn(s.cell, s.heading)}>
        <FormattedMessage {...weekday} />
      </div>
    ))}
    {workloads &&
      Object.entries(workloads).map(([time, hourlyWorkloads]) => (
        <Fragment key={time}>
          <div key={time} className={s.cell}>
            <span className={s.timeLabel}>{time}</span>
          </div>
          {hourlyWorkloads.map(hourlyWorkload => (
            <div
              key={hourlyWorkload.ts}
              className={cn(s.cell, { [s.future]: hourlyWorkload.isFuture })}
            >
              {hourlyWorkload.minutesOnline > 0 && (
                <Tooltip
                  content={
                    <FormattedMessage
                      defaultMessage="Chauffeur was online {minutes} min"
                      id="hHr2Az"
                      description="Online minutes tooltip"
                      values={{ minutes: hourlyWorkload.minutesOnline }}
                    />
                  }
                >
                  <Clock className={s.cellContent} minutes={hourlyWorkload.minutesOnline} />
                </Tooltip>
              )}
            </div>
          ))}
        </Fragment>
      ))}
  </div>
);

export { WorkingHoursCalendar };
